import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Forms = lazy(() => import("@/pages/admin/tools/forms/Forms/Forms"));
const AddForm = lazy(() => import("@/pages/admin/tools/forms/AddForm/AddForm"));
const EditForm = lazy(() => import("@/pages/admin/tools/forms/EditForm/EditForm"));

const BulkEmails = lazy(() => import("@/pages/admin/tools/bulk-emails/BulkEmails/BulkEmails"));

const LeadsProgram = lazy(() => import("@/pages/admin/tools/leads-program/LeadsProgram/index"));

const Error404 = lazy(() => import("@/pages/Error404"));

const LeadDetails = lazy(() => import("@/pages/admin/tools/leads-program/LeadDetails"));

const Campaigns = lazy(() => import("@/pages/admin/tools/leads-program/Campaigns/Campaigns"));
const CampaignDetails = lazy(() => import("@/pages/admin/tools/leads-program/CampaignDetails/CampaignDetails"));
const Agents = lazy(() => import("@/pages/admin/tools/leads-program/Agents/Agents"));

const toolsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "forms",
    children: [
      {
        index: true,
        element: <Forms />,
      },
      {
        path: "new",
        element: <AddForm />,
      },
      {
        path: ":id",
        element: <EditForm />,
      },
    ],
  },
  {
    path: "bulk-emails",
    element: <BulkEmails />,
  },
  {
    path: "leads-program",
    children: [
      {
        index: true,
        element: <LeadsProgram />,
      },
      {
        path: ":id",
        element: <LeadDetails />,
      },
    ],
  },
  {
    path: "agents",
    children: [{ index: true, element: <Agents /> }],
  },
  {
    path: "campaigns",
    children: [
      {
        index: true,
        element: <Campaigns />,
      },
      {
        path: ":id",
        element: <CampaignDetails />,
      },
    ],
  },
];

export default toolsRoutes;
